/* eslint-disable import/prefer-default-export */
import React, { useState, useEffect } from 'react';

import { Checkbox, Modal, Divider, Button } from 'antd';
import { manageSession } from 'utils';

const CheckboxGroup = Checkbox.Group;

const tm30DataColumnCheckList = [
  'CCT (K)',
  {
    label: (
      <span>
        <i>D</i>
        <sub>uv</sub>
      </span>
    ),
    value: 'Duv',
  },
  {
    label: (
      <span>
        <i>R</i>
        <sub>f</sub>
      </span>
    ),
    value: 'Rf',
  },
  {
    label: (
      <span>
        <i>R</i>
        <sub>g</sub>
      </span>
    ),
    value: 'Rg',
  },
  'P Level',
  'V Level',
  'F Level',
  {
    label: (
      <span>
        Local Chroma Shift (<i>R</i>
        <sub>
          cs,h<i>j</i>
        </sub>
        )
      </span>
    ),
    value: 'Local Chroma Shift (RCS,hj)',
  },
  {
    label: (
      <span>
        Local Hue Shift (<i>R</i>
        <sub>
          hs,h<i>j</i>
        </sub>
        )
      </span>
    ),
    value: 'Local Hue Shift (Rhs,hj)',
  },
  {
    label: (
      <span>
        Local Color Fidelity (<i>R</i>
        <sub>
          f,h<i>j</i>
        </sub>
        )
      </span>
    ),
    value: 'Local Color Fidelity (Rf,hj)',
  },
  {
    label: (
      <span>
        Sample Color Fidelity (<i>R</i>
        <sub>
          f,ces<i>i</i>
        </sub>
        )
      </span>
    ),
    value: 'Sample Color Fidelity (Rf,CESi)',
  },
  // 'Report Preview',
  // 'Go to Results',
];

const metaDataColumnCheckList = [
  'Make or Manufacturer',
  'Model or Catalog Number or ID',
  'Description',
  'Document Creator',
  'Unique Identifier',
  'Measurement Equipment',
  'Laboratory',
  'Report Number',
  'Report Date',
  'Creation Date',
  'Comments',
  'Spectral Quantity (e.g., W/nm)',
];

const luoxDataColumnCheckList = [
  'Luminance/Illuminance (Type)',
  'Luminance/Illuminance',
  // {
  //   label: (
  //     <span>
  //       CIE 1931 (<i>x</i>)
  //     </span>
  //   ),
  //   value: 'CIE 1931 xy chromaticity (x)',
  // },
  // {
  //   label: (
  //     <span>
  //       CIE 1931 (<i>y</i>)
  //     </span>
  //   ),
  //   value: 'CIE 1931 xy chromaticity (y)',
  // },
  // {
  //   label: (
  //     <span>
  //       CIE 1964 (<i>x₁₀</i>)
  //     </span>
  //   ),
  //   value: 'CIE 1964 x₁₀y₁₀ chromaticity (x₁₀)',
  // },
  // {
  //   label: (
  //     <span>
  //       CIE 1964 (<i>y₁₀</i>)
  //     </span>
  //   ),
  //   value: 'CIE 1964 x₁₀y₁₀ chromaticity (y₁₀)',
  // },
  'S-cone-opic (mW.m⁻²)',
  'M-cone-opic (mW.m⁻²)',
  'L-cone-opic (mW.m⁻²)',
  'Rhodopic (mW.m⁻²)',
  'Melanopic (mW.m⁻²)',
  'S-cone-opic EDI',
  'M-cone-opic EDI',
  'L-cone-opic EDI',
  'Rhodopic EDI',
  'Melanopic EDI',
  'S-cone-opic ELR',
  'M-cone-opic ELR',
  'L-cone-opic ELR',
  'Rhodopic ELR',
  'Melanopic ELR',
];

const checkAllLuoxDataColumnCheckList = [
  'Luminance/Illuminance (Type)',
  'Luminance/Illuminance',
  'CIE 1931 xy chromaticity (x)',
  'CIE 1931 xy chromaticity (y)',
  'CIE 1964 x₁₀y₁₀ chromaticity (x₁₀)',
  'CIE 1964 x₁₀y₁₀ chromaticity (y₁₀)',
  'S-cone-opic (mW.m⁻²)',
  'M-cone-opic (mW.m⁻²)',
  'L-cone-opic (mW.m⁻²)',
  'Rhodopic (mW.m⁻²)',
  'Melanopic (mW.m⁻²)',
  'S-cone-opic EDI',
  'M-cone-opic EDI',
  'L-cone-opic EDI',
  'Rhodopic EDI',
  'Melanopic EDI',
  'S-cone-opic ELR',
  'M-cone-opic ELR',
  'L-cone-opic ELR',
  'Rhodopic ELR',
  'Melanopic ELR',
];

const defaultColumnCheckList = [
  'CCT (K)',
  'Duv',
  'Rf',
  'Rg',
  'P Level',
  'V Level',
  'F Level',
  'Local Chroma Shift (RCS,hj)',
  'Local Hue Shift (Rhs,hj)',
  'Local Color Fidelity (Rf,hj)',
  'Sample Color Fidelity (Rf,CESi)',
  'Report Preview',
  'Go to Results',
  'Delete',
];

export const ChooseColumnsModal = ({
  showChooseColumnsModal,
  setShowChooseColumnsModal,
  setColumnVisibility,
}) => {
  const savedColumns = JSON.parse(
    sessionStorage.getItem('session-choices')
  )?.libraryTableColumns;
  const { tm30DataColumns, metadataColumns, luoxDataColumns } =
    savedColumns || {};

  const [checkAllTm30Data, setCheckAllTm30Data] = useState(false);
  const [intermediateTm30Data, setIntermediateTm30Data] = useState(false);
  const [tm30DataColumnVisibility, setTm30DataColumnVisibility] = useState(
    tm30DataColumns || defaultColumnCheckList
  );
  const [checkAllMetaData, setCheckAllMetaData] = useState(false);
  const [intermediateMetadata, setIntermediateMetadata] = useState(false);
  const [metadataColumnVisibility, setMetadataColumnVisibility] = useState(
    metadataColumns || ['Unique Identifier']
  );
  const [checkAllLuoxData, setCheckAllLuoxData] = useState(false);
  const [intermediateLuoxData, setIntermediateLuoxData] = useState(false);
  const [luoxDataColumnVisibility, setLuoxDataColumnVisibility] = useState(
    luoxDataColumns || []
  );

  useEffect(() => {
    let addDeleteToTm30Data = tm30DataColumnVisibility;
    addDeleteToTm30Data =
      !addDeleteToTm30Data.includes('Delete') &&
      addDeleteToTm30Data.push('Delete');
    const columnVisibility = {
      tm30DataColumns: tm30DataColumnVisibility,
      metadataColumns: metadataColumnVisibility,
      luoxDataColumns: luoxDataColumnVisibility,
    };
    setColumnVisibility(columnVisibility);
    manageSession({ libraryTableColumns: columnVisibility });

    // Setting check all box and intermediate checkbox to true
    if (
      tm30DataColumnVisibility.length - 1 ===
      tm30DataColumnCheckList.length
    ) {
      setCheckAllTm30Data(true);
    } else if (tm30DataColumnVisibility.length !== 0) {
      setIntermediateTm30Data(true);
    }

    if (metadataColumnVisibility.length === metaDataColumnCheckList.length) {
      setCheckAllMetaData(true);
    } else if (metadataColumnVisibility.length !== 0) {
      setIntermediateMetadata(true);
    }

    if (luoxDataColumnVisibility.length === luoxDataColumnCheckList.length) {
      setCheckAllLuoxData(true);
    } else if (luoxDataColumnVisibility.length !== 0) {
      setIntermediateLuoxData(true);
    }
  }, [
    tm30DataColumnVisibility,
    metadataColumnVisibility,
    luoxDataColumnVisibility,
    setColumnVisibility,
  ]);

  // TM30 Data columns
  const handleTm30CheckList = (list) => {
    setTm30DataColumnVisibility(list);
    setIntermediateTm30Data(
      !!list.length && list.length < defaultColumnCheckList.length
    );
    setCheckAllTm30Data(list.length === defaultColumnCheckList.length);
  };

  const handleCheckAllTm30Data = (e) => {
    setTm30DataColumnVisibility(
      e.target.checked
        ? defaultColumnCheckList
        : ['Report Preview', 'Go to Results', 'Delete']
    );
    setIntermediateTm30Data(false);
    setCheckAllTm30Data(e.target.checked);
  };

  // Metadata columns
  const handleMetadataCheckList = (list) => {
    setMetadataColumnVisibility(list);
    setIntermediateMetadata(
      !!list.length && list.length < metaDataColumnCheckList.length
    );
    setCheckAllMetaData(list.length === metaDataColumnCheckList.length);
  };

  const handleCheckAllMetadata = (e) => {
    setMetadataColumnVisibility(
      e.target.checked ? metaDataColumnCheckList : ['Unique Identifier']
    );
    setIntermediateMetadata(false);
    setCheckAllMetaData(e.target.checked);
  };

  // Luox Data columns
  const handleLuoxDataCheckList = (list) => {
    setLuoxDataColumnVisibility(list);
    setIntermediateLuoxData(
      !!list.length && list.length < checkAllLuoxDataColumnCheckList.length
    );
    setCheckAllLuoxData(list.length === checkAllLuoxDataColumnCheckList.length);
  };

  const handleCheckAllLuoxData = (e) => {
    setLuoxDataColumnVisibility(
      e.target.checked ? checkAllLuoxDataColumnCheckList : []
    );
    setIntermediateLuoxData(false);
    setCheckAllLuoxData(e.target.checked);
  };

  return (
    <Modal
      title='Choose Columns to Show in Table'
      className='choose-columns-modal flex-body'
      visible={showChooseColumnsModal}
      closable
      width={800}
      onOk={() => setShowChooseColumnsModal(false)}
      onCancel={() => setShowChooseColumnsModal(false)}
      footer={[
        <Button key='ok' onClick={() => setShowChooseColumnsModal(false)}>
          OK
        </Button>,
      ]}
    >
      <div>
        <Checkbox
          indeterminate={intermediateMetadata}
          onChange={handleCheckAllMetadata}
          checked={checkAllMetaData}
        >
          Check all Metadata
        </Checkbox>
        <Divider />
        <CheckboxGroup
          options={metaDataColumnCheckList}
          value={metadataColumnVisibility}
          onChange={handleMetadataCheckList}
        />
      </div>
      <br />
      <div>
        <Checkbox
          indeterminate={intermediateTm30Data}
          onChange={handleCheckAllTm30Data}
          checked={checkAllTm30Data}
        >
          Check all IES TM-30 Color Rendition Data
        </Checkbox>
        <Divider />
        <CheckboxGroup
          options={tm30DataColumnCheckList}
          value={tm30DataColumnVisibility}
          onChange={handleTm30CheckList}
        />
      </div>
      <br />
      <div>
        <Checkbox
          indeterminate={intermediateLuoxData}
          onChange={handleCheckAllLuoxData}
          checked={checkAllLuoxData}
        >
          Check all CIE S026 Alpha-opic Data
        </Checkbox>
        <Divider />
        <CheckboxGroup
          options={luoxDataColumnCheckList}
          value={luoxDataColumnVisibility}
          onChange={handleLuoxDataCheckList}
        />
      </div>
    </Modal>
  );
};
